import React from 'react';

function FooterComponent() {
  const savedLanguage = localStorage.getItem('language') || 'tm';

  const langs = {
    'ru': {
      'address': "Туркменистан, Национальная туристическая зона «Аваза»",
      'tel': "Тел",
      'faks': "Факс",
      'email': "Эл. почта",
    },
    'tm': {
      'address': "Türkmenistan, “Awaza” milli syýahatçylyk zolagy",
      'tel': "Tel",
      'faks': "Faks",
      'email': "El. poçta",
    },
    'en': {
      'address': "Turkmenistan, National Tourist Zone “Avaza”",
      'tel': "Tel",
      'faks': "Fax",
      'email': "Email",
    }
  };
  return (
    <footer>
      <div className="container footer-flex">
        <section className="copyright">
          <a href="/" className="footer-logo">
            <img
              src={'/media/img/icons/logo.png'}
              alt="logo"
              className="footer-logo-img"
            />
          </a>
        </section>
        <section className="footer-info-block">
          <ul className="footer-info-block_ul">
            <li className="footer-info-block_ul_li">
            {langs[savedLanguage].address}
            </li>
            <li className="footer-info-block_ul_li footer-info-block_ul_li-block">
              <a href="tel:+99324357654">{langs[savedLanguage].tel}: (+993 243) 5-76-54</a>
              <a href="tel:+99363935800">{langs[savedLanguage].tel}: (+993 63) 93-58-00</a>
              <a href="tel:+99363895855">{langs[savedLanguage].tel}: (+993 63) 89-58-55</a>
              <a href="tel:+99324357630">{langs[savedLanguage].faks}: (+993 243) 5-76-30</a>
              <a href="mailto:berkarar.travel.avaza@sanly.tm">{langs[savedLanguage].email}: berkarar.travel.avaza@sanly.tm</a>
            </li>
          </ul>
        </section>
      </div>
      <p className="copyright-text">Copyright &copy; {new Date().getFullYear()}</p>
    </footer>
  );
}

export default FooterComponent;
